let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dfhzk")).then(() => parcelRequire('6OLwk'));